require("../../../static/js/jquery/jquery.cookie.js");
require("../../../static/js/episerver-forms.js");
require("../../../static/js/membership-global.js");
require("../../../static/js/vaneck.campaign-form.js");
require("../../../static/js/global-form.js");
require("../../../static/js/analytics/vaneck.analytics.events.js");
require("../../../static/js/fix-height-by-inner-frame.js");
